import type { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { BackgroundSection } from '@xing-com/crate-layout-background-section';
import { TopBar } from '@xing-com/crate-layout-top-bar';
import { Container, MEDIA_LARGE } from '@xing-com/layout-primitives';
import { LightMode } from '@xing-com/theme-mode-switcher';
import { spaceXL, spaceXXL } from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

const HL = styled.div`
  place-content: center;
  display: none;

  ${MEDIA_LARGE} {
    display: flex;
  }
`;

const StyledContainer = styled(BackgroundSection)`
  padding-top: ${spaceXL};
  padding-bottom: ${spaceXL};

  ${MEDIA_LARGE} {
    padding-top: ${spaceXXL};
    padding-bottom: ${spaceXXL};
  }
`;

export const SearchHeaderContainer: FC<{
  children: ReactNode;
  headline: string;
}> = ({ children, headline }) => (
  <div data-testid="search-header-container">
    <TopBar title={headline} type="subheaderFlex" />
    <StyledContainer>
      <LightMode>
        <Container variant="regular">
          <HL>
            <Hero
              noMargin
              size="medium"
              as="h1"
              style={{ textAlign: 'center' }}
            >
              {headline}
            </Hero>
          </HL>
          {children}
        </Container>
      </LightMode>
    </StyledContainer>
  </div>
);
